import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { first } from 'rxjs/operators';
import { CategorySelectionModalComponent } from 'src/app/cxone/dashboard/modals/category-selection-modal/category-selection-modal.component';
import { CategorySelection, SelectedCategory } from 'src/app/cxone/dashboard/modals/category-selection-modal/category-selection-modal.model';
import { CategorySelectionModalService } from 'src/app/cxone/dashboard/modals/category-selection-modal/category-selection-modal.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-top-categories-settings',
    templateUrl: './top-categories-settings.component.html',
    styleUrls: ['./top-categories-settings.component.scss'],
    providers: [DialogService]
})
export class TopCategoriesSettingsComponent implements OnInit, OnDestroy {
    @Input() moduleManager: ModuleManager;

    //settings
    public selectedCategories: SelectedCategory[] = [];

    //subscriptions used 
    private onSettingsSub;
    private onCancelledSub;
    private onAppliedSub;
    private modalRef: DynamicDialogRef = null;

    constructor(private catSrvc: CategorySelectionModalService, private dialogSrvc: DialogService) { }

    ngOnInit(): void {
        this.moduleManager.addSetting({
            name: 'selectedCategories',
            getValue: () => this.selectedCategories,
            onSettingLoaded: async (value) => {
                if ((value as any[]).length > 0)
                    this.selectedCategories = value;
                else {
                    this.selectedCategories = await this.getInitialCategories();
                    this.moduleManager.saveSettings();
                }
            },
            defaultValue: []
        });
        this.moduleManager.customSettingsAdded = true;
        //subscribe to cancel/save events to remove css that hides agent selection
        this.onSettingsSub = this.moduleManager.slideoutSettingsManager.subscribe((value) => this.settingsMangerHandler(value));
    }

    ngOnDestroy() {
        this.unhideAgentSelection();
        this.onSettingsSub.unsubscribe();
    }

    settingsMangerHandler(value) {
        if (value == null)
            return;
        this.hideAgentSelection();
        this.onCancelledSub = value.onSettingsCancelled.subscribe((value2) => this.unhideAgentSelection(value));
        this.onAppliedSub = value.onSettingsApplied.subscribe((value2) => this.unhideAgentSelection(value));
    }

    hideAgentSelection() {
        let style = document.createElement('style');
        const head = document.head || document.getElementsByTagName('head')[0];
        style.id = "HideAgentSelection";
        style.type = 'text/css';
        style.appendChild(document.createTextNode('.group-selector-container > div:nth-child(2).col{display: none !important;}'));
        head.appendChild(style);
    }

    unhideAgentSelection(value = null) {
        let style = document.getElementById("HideAgentSelection");
        if (!!style)
            document.head.removeChild(style);
        if (value != null) {
            this.onCancelledSub.unsubscribe();
            this.onAppliedSub.unsubscribe();
        }
    }

    onClose(value: SelectedCategory[]) {
        if (value == null || value == undefined)
            return;
        this.selectedCategories.splice(0);
        value.forEach(sCat => {
            this.selectedCategories.push(sCat);
        });
    }

    async getInitialCategories(): Promise<SelectedCategory[]> {
        return await this.catSrvc.getInitialCategories(this.moduleManager.getModuleKey());
    }

    showCategoriesModal() {
        if (!this.modalRef) {
            this.modalRef = this.dialogSrvc.open(CategorySelectionModalComponent, {
                width: '540px',
                height: '406px',
                data: {
                    moduleKey: this.moduleManager.getModuleKey(),
                    hasAutoSelect: false,
                    manualSelect: true,
                    multiSelect: true,
                    selectedCategories: this.selectedCategories,
                }
            });
            this.modalRef.onClose.pipe(first()).subscribe((value: CategorySelection) => {
                if (value != null)
                    this.onClose(value.selectedCategories);
                this.modalRef = null;
            })
        }
    }
}
